import React from 'react';
import logo from '../logo.svg';

export class OnboardingErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('[onboarding] render error:', error, info?.componentStack);
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="auth-outer-container onboarding-outer">
                <div className="auth-inner-container onboarding-inner">
                    <div className="auth-logo-container">
                        <img src={logo} alt="Clozers" className="auth-logo" />
                    </div>
                    <div className="onboarding-step onboarding-step--centered">
                        <h1 className="heading-large-bold colour-primary">Something went wrong</h1>
                        <p className="body-regular colour-secondary">
                            An unexpected error occurred. Please refresh the page to continue.
                        </p>
                        <button
                            className="size-large primary-button button-radius-normal cursor-pointer"
                            onClick={() => window.location.reload()}
                            type="button"
                        >
                            <div className="size-large-padding">
                                <span className="body-bold colour-white block-text text-align-center">Refresh page</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
